// extracted by mini-css-extract-plugin
export default {"hideTooltip":"e--z","fadeIn":"f--z","delay":"g--z","recommendedSizeTooltip":"h--z"};